import { CustomerPagePath } from "views/constants/enums/pageTitle";

// Homeに飛ぶかloginに飛ぶかを判断する
export const LogoNavLink = (path: string) => {
  switch (path) {
    case CustomerPagePath.Login:
      return CustomerPagePath.Login;
    case CustomerPagePath.SendSMS:
      return CustomerPagePath.Login;
    case CustomerPagePath.ReissuePassword:
      return CustomerPagePath.Login;
    case CustomerPagePath.AddvanceQuestion:
      return CustomerPagePath.Login;
    case CustomerPagePath.ConsentSecurities:
      return CustomerPagePath.Login;
    case CustomerPagePath.ConsentTrust:
      return CustomerPagePath.Login;
    case CustomerPagePath.CustomerInfo:
      return CustomerPagePath.Login;
    case CustomerPagePath.DepositAccount:
      return CustomerPagePath.Login;
    case CustomerPagePath.Employment:
      return CustomerPagePath.Login;
    case CustomerPagePath.InvestmentInfo:
      return CustomerPagePath.Login;
    case CustomerPagePath.RequestConfirm:
      return CustomerPagePath.Login;
    case CustomerPagePath.RequestComplete:
      return CustomerPagePath.Login;
    default:
      return CustomerPagePath.Home;
  }
};
